import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import DevOpsIntegrationHelmet from 'common/helmets/DevOpsIntegrationHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import DevOps1 from 'img/landing/devops-1.webp';
import DevOps2 from 'img/landing/devops-2.webp';
import DevOps3 from 'img/landing/devops-3.webp';

import DevOpsLogo from 'img/canny-devops-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class DevOpsLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed DevOps Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <DevOpsIntegrationHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={DevOpsLogo} />
              <div className="text">
                <h1 className="title">Canny for Azure DevOps</h1>
                <div className="subtitle">Sync feedback between Canny and Azure&nbsp;DevOps</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Install Azure DevOps"
                    installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fazure-devops"
                  />

                  <a
                    href="http://help.canny.io/en/articles/6474924-azure-devops-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={DevOps1} />
              </div>
              <div className="featureText">
                <div className="title">Link Canny posts with DevOps Work&nbsp;Items</div>
                <div className="subtitle">
                  Push posts from Canny to Azure DevOps and link between the&nbsp;two.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={DevOps2} />
              </div>
              <div className="featureText">
                <div className="title">Push posts to Azure&nbsp;DevOps</div>
                <div className="subtitle">
                  See a great idea in Canny? Push it over to Azure DevOps as a task and
                  automatically link them&nbsp;together.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={DevOps3} />
              </div>
              <div className="featureText">
                <div className="title">Keep statuses in&nbsp;sync</div>
                <div className="subtitle">
                  No more worrying about losing track of status updates. Create rules to
                  automatically sync statuses between Azure DevOps and&nbsp;Canny.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({
    trackEvent: TrackEventContext,
    viewer: ViewerContext,
  }),
  hot,
)(DevOpsLanding);
